import { AbstractControl } from '@angular/forms'

/**
 * Validates a LinkedIn URL based on a regex pattern
 * @param control Abstract control
 * @returns error or null
 */
export function ValidateLinkedInUrl(control: AbstractControl) {
  // Allow empty values, required validation will handle this
  if (!control.value || control.value === 'linkedin.com/') return null

  // Check for spaces - LinkedIn URLs should not contain spaces
  if (control.value.includes(' ')) return { invalidLinkedInUrl: { message: 'LinkedIn URL cannot contain spaces' } }

  // Regex pattern for LinkedIn URLs
  // Supports any path after linkedin.com/ including query parameters and hash fragments
  const regex = /^(https?:\/\/)?(www\.)?linkedin\.com\/[a-zA-Z0-9-_.\/?=&%#]+$/i

  if (!regex.test(control.value))
    return { invalidLinkedInUrl: { message: 'Please enter a valid LinkedIn URL (e.g., linkedin.com/in/yourname or linkedin.com/company/yourcompany)' } }

  return null
}
